<template>
  <div class="cursor-container">
    <div class="cursor" ref="cursor"></div>
  </div>
</template>

<script>
// import engine from '../scripts/engine';
// import apollo from '../scripts/apollo';

export default {
  name: 'CursorContainer',

  mounted() {
    // engine.add(() => {
    //   this.$refs.cursor.style.transform = `translate3d(${apollo.ref.mouse.x}px, ${apollo.ref.mouse.y}px, 0px)`;
    // }, 'render-mouse');
  },
};
</script>

<style lang="scss" scoped>
.cursor-container {
  @extend %full-fixed;
  pointer-events: none;
  mix-blend-mode: difference;

  @include mq($and: $is-touch-device) {
    visibility: hidden;
  }

  .cursor {
    width: 30px;
    height: 30px;
    border: 2px solid $color-white;
    border-radius: 100%;
  }
}
</style>
